import api from "./api";

export const fetchOccurrences = async () => {
  const { data } = await api.get("/request_seen/");
  return Array.isArray(data) ? data : [];
};

export const toggleOccurrenceRead = async (id) => {
  const { data } = await api.patch(`/request_seen/${id}/toggle/`);
  return data;
};

const occurrencesService = {
  fetchOccurrences,
  toggleOccurrenceRead,
};

export default occurrencesService;